import React from 'react';
import DocumentTemplate from './utils/DocumentTemplate';
import app from './firebase.js';
import './diploma.css';

const DiplomeSans = () => {
    return (
        <DocumentTemplate
            documentType="diplome sans"
            app={app}
            customStyles={{
                container: {
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                }
            }}
        />
    );
};

export default DiplomeSans;
